import { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/browser';
import type { ReauthIntent } from '~/composables/useReauth';
import RequestService from './request';

export type ReauthMethod = 'totp' | 'webauthn';

export interface ReauthChallenge {
    methods: ReauthMethod[];
    webauthn: PublicKeyCredentialRequestOptionsJSON | null;
}

export interface ReauthVerifyData {
    intent: ReauthIntent;
    password: string;
    totp_token?: string;
    webauthn?: {
        id: string;
        type: string;
        raw_id: string;
        response: {
            authenticator_data: string;
            client_data_json: string;
            signature: string;
            user_handle: string | null;
        };
    };
}

export interface ReauthVerifyResponse {
    token: string;
    expires_in: number;
}

class ReauthService {
    challenge(intent: ReauthIntent): Promise<ReauthChallenge> {
        return RequestService.post('/security/reauth/challenge', { intent });
    }

    verify(data: ReauthVerifyData): Promise<ReauthVerifyResponse> {
        return RequestService.post('/security/reauth/verify', data);
    }
}

export default new ReauthService();
